import {
  CREATE_PAGE_VIEWER,
  GET_PAGE_BREAKS,
  GET_THUMBNAILS,
  GET_USER_INFO,
} from './jigsaw-methods';
import { isCookieError } from '../jigsaw-helpers';
import { createSelector } from 'reselect';

const emptyArray = [];

export function getCurrentTitle(state) {
  const data = state.jigsaw[CREATE_PAGE_VIEWER].data;
  return data ? data.title : null;
}

export function getCurrentCoverTemplate(state) {
  const data = state.jigsaw[CREATE_PAGE_VIEWER].data;
  return data ? data.coverURL : null;
}

export function getCurrentCoverWidths(state) {
  const data = state.jigsaw[CREATE_PAGE_VIEWER].data;
  return data ? data.coverWidths : [];
}

export function isFixedLayout(state) {
  const data = state.jigsaw[CREATE_PAGE_VIEWER].data;
  return data && data.layout === 'fixed';
}

export function isPBK(state) {
  const data = state.jigsaw[CREATE_PAGE_VIEWER].data;
  return data && data.vbkType === 'pbk';
}

export function isBookNotFound(state) {
  const err = state.jigsaw[CREATE_PAGE_VIEWER].errorInfo;
  return err && err.errorCode === 404;
}

export function isBookNoAccess(state) {
  const err = state.jigsaw[CREATE_PAGE_VIEWER].errorInfo;
  return err && err.errorCode === 403;
}

export function currentBookHasAncillaries(state) {
  const data = state.jigsaw[CREATE_PAGE_VIEWER].data;
  return data && data.hasAncillaries;
}

export function hasCookieError(state) {
  if (state.jigsaw[GET_USER_INFO].hasError) {
    return isCookieError(state.jigsaw[GET_USER_INFO].errorInfo);
  }
  return false;
}

export function getInteractionErrors(state) {
  return state.jigsaw.interactionErrors;
}

export function getLastInteractionError(state) {
  const errors = getInteractionErrors(state);
  if (errors.length > 0) {
    return errors[errors.length - 1];
  }
  return null;
}

export function getThumbnails(state) {
  const base = state.jigsaw[GET_THUMBNAILS].data;
  return base ? base.thumbnails : emptyArray;
}

export function hasThumbnails(state) {
  return getThumbnails(state).length > 0;
}

export function thumbsLoading(state) {
  return state.jigsaw[GET_THUMBNAILS].isFetching;
}

export function getThumbnailForBookmark(state, bookmark) {
  return getThumbnails(state).filter(t => t.label === bookmark.page)[0];
}

export function bookHasPageBreaks(state) {
  const base = state.jigsaw[CREATE_PAGE_VIEWER].data;
  return base && base.hasPageBreaks;
}

export function bookHasSpreads(state) {
  const base = state.jigsaw[CREATE_PAGE_VIEWER].data;
  return base && base.dpsAvailable;
}

export function getPageBreaks(state) {
  const base = state.jigsaw[GET_PAGE_BREAKS].data;
  if (base) {
    return base.pagelist;
  }
  return emptyArray;
}

export function hasPageBreakData(state) {
  return getPageBreaks(state).length > 0;
}

export const getPageBreaksAsThumbs = createSelector(
  state => getPageBreaks(state),
  pagelist =>
    pagelist.map(p => ({
      cfiref: p.cfiWithoutAssertions,
      label: p.label,
      urlref: p.url,
      images: [],
    }))
);



// WEBPACK FOOTER //
// ./src/app/api/redux-jigsaw/jigsaw-selectors.js